//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DayReportPushDrawer from "./modules/DayReportPushDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { querySiteTree, queryUserTreeList } from '@/api/api';
import moment from 'moment';
export default {
  name: "DayReportPushList",
  mixins: [JeecgListMixin],
  components: {
    DayReportPushDrawer: DayReportPushDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/day/report/push',
      pageTitle: '运维日报微信推送',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'title',
        colName: 'title',
        title: '标题',
        align: "center",
        sorter: false
      }, {
        dataIndex: 'pushSiteId',
        colName: 'push_site_id',
        title: '推送站点',
        align: "center",
        sorter: false,
        scopedSlots: {
          customRender: 'pushSiteSlot'
        }
      }, {
        dataIndex: 'pushUserId',
        colName: 'push_user_id',
        title: '推送人员',
        align: "center",
        sorter: false,
        scopedSlots: {
          customRender: 'pushUserSlot'
        }
      }, {
        dataIndex: 'pushTime',
        colName: 'push_time',
        title: '推送时间',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'pushHeader',
        colName: 'push_header',
        title: '推送标头',
        align: "center",
        sorter: false
      }, {
        dataIndex: 'pushTail',
        colName: 'push_tail',
        title: '推送标尾',
        align: "center",
        sorter: false
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '状态',
        align: "center",
        sorter: false
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      userTree: [],
      siteTree: []
    };
  },
  created: function created() {
    this.queryUserTree();
    this.getSiteTree();
  },
  computed: {},
  methods: {
    getSiteTree: function getSiteTree() {
      // 站点树
      var that = this;
      querySiteTree({
        addrType: 1
      }).then(function (res) {
        if (res.success) {
          that.pushDisable(res.result);
          that.siteTree = res.result;
        }
      });
    },
    pushDisable: function pushDisable(tree) {
      for (var i = 0; i < tree.length; i++) {
        var node = tree[i];

        if (node.children) {
          tree[i].disabled = true;
          this.pushDisable(node.children);
        } else {
          node.disabled = false;
        }
      }
    },
    queryUserTree: function queryUserTree() {
      // 用户
      var that = this;
      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }
        }
      });
    },
    moment: moment
  }
};